module.exports = __webpack_public_path__ + "img/docs.613efb83.png";